<template>
  <div>
    <b-row class="my-3">
      <b-col sm="3">
        <label>Value Type:</label>
      </b-col>
      <b-col sm="9">
        <b-form-group>
          <b-form-radio-group
            v-model="config.value_type"
            :options="valueTypeOptions"
            @change="onChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { CHART_VALUE_TYPES } from '@/store';

export default {
  name: 'PieConfig',
  props: {
    initialConfig: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      config: {
        value_type:
          this.initialConfig.value_type || CHART_VALUE_TYPES.PERCENTAGE,
      },
    };
  },
  mounted() {
    this.onChange();
  },
  computed: {
    valueTypeOptions() {
      return this.$store.state.chartValueTypeOptions;
    },
    orientationOptions() {
      return this.$store.state.chartOrientationOptions;
    },
  },
  methods: {
    onChange() {
      this.$emit('configChanged', this.config);
    },
  },
};
</script>

<style scoped></style>
